import { render } from "./ShowComponent.vue?vue&type=template&id=0fc9aa0a"
import script from "./ShowComponent.vue?vue&type=script&lang=js"
export * from "./ShowComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__